import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { DrawerComponent } from './drawer.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule
  ],
  declarations: [
    DrawerComponent
  ],
  exports: [
    DrawerComponent
  ]
})
export class DrawerModule { }
